import React, { useContext } from 'react';
import { Link, UnorderedList } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import themeStyles from '../Footer.styles';
import useLanguageLinkUrl from '../service/useLanguageLinkUrl';
import { getFooterGtmTags } from '../utils';

const LangLink = themeStyles.apply(Link, 'BottomLink');
const List = themeStyles.apply(UnorderedList, 'LinkList');
const LinkContainer = themeStyles.apply('li', 'LinkContainer');

const LanguageLinks = ({ pullRight }) => {
  const { languageMenu, languageShowLangCode, styles, footerFontFamilyBold } = useContext(FooterContext);
  const formatUrl = useLanguageLinkUrl();

  return (
    <List flex data-testid="cy-footer-languages" pullRight={pullRight}>
      {languageMenu?.items?.map(item => {
        const selectedLang = languageMenu.current === item.itemId;
        const itemName = item?.itemName || item?.itemId;

        return (
          <LinkContainer key={`li-${itemName}`} $mb={0} borderLeft data-testid="cy-footer-language">
            <LangLink
              color={selectedLang ? styles.highlightLangColor : 'grey.0'}
              href={formatUrl(item?.url?.href) || undefined}
              tabIndex={0}
              aria-label={item?.label}
              fontFamily={footerFontFamilyBold}
              {...getFooterGtmTags(item.displayName)}
              {...styles.languageLink}
            >
              {languageShowLangCode ? itemName.toUpperCase() : item?.label}
            </LangLink>
          </LinkContainer>
        );
      })}
    </List>
  );
};

export default LanguageLinks;
